import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowDown } from '@fortawesome/free-solid-svg-icons/faArrowDown';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons/faArrowUp';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons/faCaretDown';
import { faCaretRight } from '@fortawesome/free-solid-svg-icons/faCaretRight';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle';
import { faCheckSquare } from '@fortawesome/free-solid-svg-icons/faCheckSquare';
import { faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons/faCloudUploadAlt';
import { faCog } from '@fortawesome/free-solid-svg-icons/faCog';
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload';
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons/faEllipsisH';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons/faEllipsisV';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons/faEyeSlash';
import { faFile } from '@fortawesome/free-solid-svg-icons/faFile';
import { faLongArrowAltLeft } from '@fortawesome/free-solid-svg-icons/faLongArrowAltLeft';
import { faMinus } from '@fortawesome/free-solid-svg-icons/faMinus';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons/faPaperPlane';
import { faPen } from '@fortawesome/free-solid-svg-icons/faPen';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons/faPlusCircle';
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner';
import { faSquare } from '@fortawesome/free-solid-svg-icons/faSquare';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons/faTimesCircle';
import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash';
import { faCaretLeft } from '@fortawesome/free-solid-svg-icons/faCaretLeft';
import { faUndo } from '@fortawesome/free-solid-svg-icons/faUndo';
import { faUpload } from '@fortawesome/free-solid-svg-icons/faUpload';
import { faUsers } from '@fortawesome/free-solid-svg-icons/faUsers';
import { faCommentAlt as farCommentAlt } from '@fortawesome/free-regular-svg-icons/faCommentAlt';
import { faMinusSquare as farMinusSquare } from '@fortawesome/free-regular-svg-icons/faMinusSquare';
import { faSquare as farSquare } from '@fortawesome/free-regular-svg-icons/faSquare';
import Vue from 'vue';

export function fontAwesomeInit() {
  library.add(
    faArrowDown,
    faArrowLeft,
    faArrowUp,
    faCaretDown,
    faCaretRight,
    faCaretLeft,
    faCheck,
    faCheckCircle,
    faCheckSquare,
    faCloudUploadAlt,
    faCog,
    farCommentAlt,
    faDownload,
    faEllipsisH,
    faEllipsisV,
    faExclamationCircle,
    faEye,
    faEyeSlash,
    faFile,
    faLongArrowAltLeft,
    faMinus,
    farMinusSquare,
    farSquare,
    faPaperPlane,
    faPen,
    faPlus,
    faPlusCircle,
    faSpinner,
    faSquare,
    faTimes,
    faTimesCircle,
    faTrash,
    faUndo,
    faUpload,
    faUsers,
  );

  Vue.component('font-awesome-icon', FontAwesomeIcon);
}
